import { watch } from 'vue'

import { useOrpheusConsentStore } from '../stores/orpheusConsentStore'
import { useOrpheusSettingsStore } from '../stores/orpheusSettingsStore'
import { useOrpheusSetupDraftStore } from '../stores/orpheusSetupDraftStore'
import { useOrpheusStore } from '../stores/orpheusStore'

import { useWorkspace } from '@/features/account'
import { registerSessionReset } from '@/features/auth'

/** Install workspace/logout ownership resets once from the app composition root. */
export function registerOrpheusLifecycle(): () => void {
  const store = useOrpheusStore()
  const consent = useOrpheusConsentStore()
  const settings = useOrpheusSettingsStore()
  const drafts = useOrpheusSetupDraftStore()
  const { workspaceId } = useWorkspace()

  // Consent, the provider key and the confirm buttons' states all belong to one tenant: a switch
  // re-reads them rather than showing the previous account's answer for a frame.
  function resetAll(): void {
    store.reset()
    consent.reset()
    settings.reset()
    drafts.reset()
  }

  const stopWorkspace = watch(
    workspaceId,
    (next, previous) => {
      if (String(next ?? '') !== String(previous ?? '')) resetAll()
    },
    { flush: 'sync' },
  )
  const unregisterSession = registerSessionReset(resetAll)
  return () => {
    stopWorkspace()
    unregisterSession()
  }
}
